import React from "react";
import { Box } from "@mui/system";
import { Grid } from "@mui/material";
import renderRelianceIPAOptionComponent from "./relianceIPAHelper/renderRelianceIPAOptionComponent";

const renderOptionComponent = (props, option, productName) => {
  if (productName === "Reliance IPA") {
    return renderRelianceIPAOptionComponent(props, option);
  }
  return (
    <li {...props}>
      <Grid container alignItems="center">
        <Grid
          item
          sx={{
            width: "calc(100% - 44px)",
            wordWrap: "break-word",
          }}
        >
          <Box component="span">{`${option?.toString()}`}</Box>
        </Grid>
      </Grid>
    </li>
  );
};

export default renderOptionComponent;
